// extracted by mini-css-extract-plugin
export default {"inputBox":"YjE_ic5GmWH8Q_rJ2eMJ"};